import { render } from "./BinaryView.vue?vue&type=template&id=5dfccb63"
import script from "./BinaryView.vue?vue&type=script&lang=js"
export * from "./BinaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__